import { QuestionButtonsField, QuestionRadioButtonsField, QuestionYesNoField } from 'components/Questionnaires/fields';
import { requiredValidator } from 'components/Questionnaires/validators';
import { uploadSupportingDocField } from 'common/questionnaires/definitions/fields';
import { getKey, DocumentKeys } from 'common/forms/documentTypes';

export function usPersonOrIntermediaryBlock({ id, title, info, visible, isCh4Block }) {
  return {
    id,
    title,
    component: undefined,
    visible,
    info,
    questions: [
      {
        id: 'entity',
        label: 'questionnaire.usPersonIntermediary.label',
        component: QuestionButtonsField,
        componentProps: {
          buttons: [
            { value: 'UsPerson', text: 'questionnaire.buttons.usPerson' },
            { value: 'Intermediary', text: 'questionnaire.buttons.intermediary' }
          ]
        },
        visible: true,
        validation: {
          conditions: [
            { condition: requiredValidator, message: 'questionnaire.usPersonIntermediary.errorMessage' }
          ]
        },
      },
      {
        id: 'usPersonCertification',
        component: QuestionRadioButtonsField,
        componentProps: {
          items: 'questionnaire.usPersonIntermediary.usPersonCertification.items',
          inputName: 'territoryFi'
        },
        label: 'questionnaire.usPersonIntermediary.usPersonCertification.label',
        visible: bAnswers => bAnswers?.entity === 'UsPerson',
        validation: {
          conditions: [
            { condition: requiredValidator, message: 'questionnaire.usPersonIntermediary.usPersonCertification.errorMessage' }
          ]
        },
      },
      {
        id: 'intermediaryCertification',
        component: QuestionYesNoField,
        label: 'questionnaire.usPersonIntermediary.intermediaryCertification.label',
        visible: bAnswers => bAnswers?.entity === 'Intermediary',
        validation: {
          conditions: [
            { condition: requiredValidator, message: 'questionnaire.usPersonIntermediary.intermediaryCertification.errorMessage' }
          ]
        },
      },
      uploadSupportingDocField({
        id: 'withholdingStatement',
        docType: getKey(DocumentKeys.SIMPLE_WHD_STATEMENT),
        visible: bAnswers => !isCh4Block && bAnswers?.entity === 'Intermediary',
        hasFootnote: true
      }),
    ]
  };
}

export default usPersonOrIntermediaryBlock;
